import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, ClickAwayListener, colors, Grow } from "@material-ui/core";
import { IoMdArrowDropdown } from "react-icons/io";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import SignOutScreen from "../../screens/signout/SignOut";
import { formatPhoneNumber } from "../../common/Hooks";
import { useAuthenticationContext } from "../../context/UserContext";
import {ICIPAdminSettingsScreen} from "../../screens/admin-settings-screen/ICIPAdminSettingsScreen";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
  },

  profileSmallPresentation: {
    height: "100%",
    width: "100%",
    cursor: "pointer",
    paddingLeft: theme.spacing(2),

    "& .arrow": {
      marginLeft: 4,
      color: theme.palette.common.white,
    },

    "& .userPicture": {
      height: 40,
      width: 40,
      borderRadius: 40,
      backgroundColor: "#1b265c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "& img": {
        height: 32,
        width: 32,
        borderRadius: "40px",

        [theme.breakpoints.down("xs")]: {
          height: 28,
          width: 28,
        },
      },
    },
  },

  dropdown: {
    position: "absolute",
    top: 64,
    right: 0,
    zIndex: 10,
    width: 200,

    padding: "4px 0",
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    transition: theme.transitions.create(["width"]),
    border: "1px solid #f2f2f2",

    "& .dropdownItem": {
      display: "block",
      padding: "6px 14px 8px 14px",
      fontSize: 13,
      fontWeight: theme.typography.fontWeightMedium,
      textDecoration: "none",
      color: theme.palette.text.primary,

      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",

      "&:hover": {
        backgroundColor: "#f8f8f8",
        textDecoration: "none",
      },
      "& span": {
        display: "inline-block",
      },
      "&.logOut": {
        color: colors.red[500],
        fontWeight: theme.typography.fontWeightBold,
        "&:hover": {
          backgroundColor: colors.red[50],
        },
      }
    },
  },

  dropdownHeader: {
    padding: "10px 14px",
    fontWeight: theme.typography.fontWeightMedium,
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "#f8f8f8",
      textDecoration: "none",
    },

    "& .name": {
      fontSize: 13,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      fontWeight: theme.typography.fontWeightBold,
    },

    "& .login": {
      fontSize: 12,
      color: colors.grey[600],
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
}));

export const ProfileAction = (props: any) => {
  const classes = useStyles(props);
  // Context
  const [user] = useAuthenticationContext();
  // State
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.root}>
        <Box
          component="div"
          className={classes.profileSmallPresentation}
          display="flex"
          alignItems="center"
          flexWrap="nowrap"
          justifyContent="center"
          onClick={handleClick}
        >
          <div className="userPicture">
            <img src={user.avatar()} alt="" />
          </div>
          <span className="arrow">
            <IoMdArrowDropdown size={14} />
          </span>
        </Box>
        <Grow in={open} disableStrictModeCompat={false}>
          <Box className={classes.dropdown} zIndex="modal">
            <Box className={classes.dropdownHeader}>
              <Box component="div" className="name">
                {user.fullName()}
              </Box>
              <Box component="div" className="login">
                @{formatPhoneNumber(user.user_detail.telephone, true)}
              </Box>
            </Box>
            {
              user.isAdmin() ? (
                  <Link to={`${ICIPAdminSettingsScreen.routeName}`} className="dropdownItem" onClick={handleClick}>
                    <FormattedMessage id="sharedScreen.settings" />
                  </Link>
              ) : <></>
            }
            <Link to={`${SignOutScreen.routeName}`} className="dropdownItem logOut">
              <FormattedMessage id="sharedScreen.signOut" />
            </Link>
          </Box>
        </Grow>
      </div>
    </ClickAwayListener>
  );
};
